import { NavLink } from 'react-router-dom'

import {
  MainNavigation,
  MainNavigationLink,
  ResourcesMenu,
} from 'components/MainNavigation'
import { useAuth } from 'components/Auth'
import { useStripePaymentPortal } from 'pages/Programming/hooks'
import { useSettings } from 'components/Settings'
import style from './style.module.scss'
import { Role } from 'types'
import { Text } from '@crossfit/design-system'
import { useAffiliate } from 'hooks/useAffiliate'

function Header() {
  const { user } = useAuth()
  const {
    selectedAffiliate: affiliate,
    canAccessProgramming,
    canAccessDashboard,
    canAccessPlaybook,
    canAccessContentKit,
    canAccessPartnerNetwork,
    canAccessRoundtables,
    canAccessStarterKit,
  } = useAffiliate()
  const showStarterKit =
    useSettings((s) => s.data.exposeStarterKit) && canAccessStarterKit

  return (
    <MainNavigation
      userMenu={
        user && (
          <>
            {affiliate ? (
              <Text
                as='p'
                type='overline'
                size='xs'
                className={style.subHeader}
              >
                Affiliate Toolkit
              </Text>
            ) : null}
            <MainNavigationLink as={NavLink} to=''>
              Affiliate Dashboard
            </MainNavigationLink>
            {affiliate &&
              affiliate.roles?.some((r) =>
                [Role.LOR, Role.Manager].includes(r as Role),
              ) && (
                <MainNavigationLink as={NavLink} to='admin/directory-page'>
                  Affiliate Management
                </MainNavigationLink>
              )}
            {affiliate && affiliate.roles?.includes(Role.Coach) && (
              <MainNavigationLink as={NavLink} to='admin/staff'>
                Coaches & Staff
              </MainNavigationLink>
            )}
            {affiliate && affiliate.roles?.includes(Role.LOR) && (
              <MainNavigationLink
                href='https://affiliate.crossfit.com/affiliate-portal/affiliateprofile'
                target='_blank'
                rel='noreferrer'
              >
                Affiliate Portal
              </MainNavigationLink>
            )}
            <Text as='p' type='overline' size='xs' className={style.subHeader}>
              Personal
            </Text>
            <MainNavigationLink
              as={'a'}
              href='https://www.crossfit.com/dashboard'
            >
              My Account
            </MainNavigationLink>
            <MainNavigationLink
              as={'a'}
              href='https://games.crossfit.com/manage-competition/athlete'
            >
              Competition Dashboard
            </MainNavigationLink>

            <MainNavigationLink className='logout' as={NavLink} to='/logout'>
              Log Out
            </MainNavigationLink>
          </>
        )
      }
    >
      {user && (
        <>
          {canAccessDashboard && (
            <MainNavigationLink as={NavLink} to=''>
              Dashboard
            </MainNavigationLink>
          )}
          {canAccessProgramming && (
            <MainNavigationLink as={NavLink} to='/programming'>
              Programming
            </MainNavigationLink>
          )}

          {canAccessPartnerNetwork && (
            <MainNavigationLink as={NavLink} to='/partner-network'>
              Partner Network
            </MainNavigationLink>
          )}

          {canAccessRoundtables && (
            <MainNavigationLink as={NavLink} to='/roundtables'>
              Roundtables
            </MainNavigationLink>
          )}
          {(canAccessContentKit ||
            showStarterKit ||
            canAccessContentKit ||
            canAccessPlaybook) && (
            <ResourcesMenu>
              {canAccessPlaybook && (
                <MainNavigationLink as={NavLink} to='/playbook'>
                  Playbook
                </MainNavigationLink>
              )}
              {showStarterKit && (
                <MainNavigationLink as={NavLink} to='/starter-kit'>
                  Starter Kit
                </MainNavigationLink>
              )}
              {canAccessContentKit && (
                <MainNavigationLink as={NavLink} to='/marketing'>
                  Marketing
                </MainNavigationLink>
              )}
            </ResourcesMenu>
          )}
        </>
      )}
    </MainNavigation>
  )
}

export default Header
